import React from 'react'
import { Route, Routes } from 'react-router-dom'

import Pricing from './Pricing'
import Demo from './Demo'
import Features from './Features'
import FeatureComparison from './FeatureComparison'
import Personal from './Personal'
import Home from './Home'
import Team from './Team'
import Business from './Business'
import PageWrapper from '../Shared/PageWrapper'
import Header from './Header'
import Footer from './Footer'
import { withUserStore } from '../../contexts/UserStore'
import { withModals } from '../../contexts/modals'

const Marketing = () => {
  return (
    <div>
      <Header />
      <div className="page-content container">
        <Routes>
          <Route path="personal" element={<PageWrapper name="Personal Edition"><Personal /></PageWrapper>} />
          <Route path="team" element={<PageWrapper name="Team Edition"><Team /></PageWrapper>} />
          <Route path="business" element={<PageWrapper name="Team Edition"><Business /></PageWrapper>} />
          <Route path="pricing" element={<PageWrapper name="Pricing"><Pricing /></PageWrapper>} />
          <Route path="features" element={<PageWrapper name="Features"><Features /></PageWrapper>} />
          <Route exact path="/feature_comparison" element={<PageWrapper name="Feature Comparison"><FeatureComparison /></PageWrapper>} />
          <Route exact path="/demo" element={<PageWrapper name="Demo"><Demo /></PageWrapper>} />
          <Route exact path="/" element={<PageWrapper name=""><Home /></PageWrapper>} />
        </Routes>
      </div>

      <Footer />
    </div>
  )
}

export default withUserStore(withModals(Marketing))
